
import Button from "@/components/base/Button"
import themes from "@/mixins/themes"
import jobFeatures from "@/mixins/jobFeatures"
import JobPublicContactPerson from "@/components/job/JobPublicContactPerson"
import JobApprenticeshipDatePicker from "@/components/job/jobpage/JobApprenticeshipDatePicker"

import { chevron_down } from "assets/icons/js"

export default {
    name: "JobPopupCard",
    components: { Button, JobPublicContactPerson, JobApprenticeshipDatePicker },
    mixins: [jobFeatures, themes],
    model: {
        prop: "step",
        event: "change",
    },
    props: {
        job: {
            type: Object,
            required: true,
        },
        step: {
            type: Number,
            default: 0,
            validator: (val) => val >= 0 && val <= 2,
        },
    },
    emits: [
        "change",
        "start-request",
        "interested",
        "interested-external",
        "close",
    ],
    icons: {
        chevron_down,
    },
    computed: {
        activatorBtnLabel() {
            return this.job.is_external_application_active
                ? "Bewerbungsoptionen"
                : "für den Beruf bewerben"
        },
        greetingText() {
            const business = this.job.business
            let displayName = business.name
            const cp = business?.public_contact_person
            if (cp?.firstname || cp?.lastname) {
                displayName = `${cp.firstname ?? ""} ${cp.lastname ?? ""}`
            }
            return `"Willkommen beim Einblick in die Ausbildung ${this.job.name}. Ich bin ${displayName} und wenn du Fragen oder Interesse hast, dann kannst du dich bei mir melden."`
        },
        externalApplicationUrl() {
            if (!this.featureExternalApplication) return
            const url =
                this.job.external_application_url ?? this.job.external_website
            if (!url) return ""
            return url
        },
    },
    methods: {
        onInterested() {
            this.$oabalytics.trackEvent("job-interest")
            this.$survey?.startTimer()
            this.$emit("interested")
        },
        onExternalBtnClick() {
            this.$oabalytics.trackEvent("job-application-external")
            this.$emit("interested-external")
        },
        onContinue() {
            if (this.job.is_external_application_active) {
                this.$emit("change", 1)
            } else {
                this.$emit("change", 2)
            }
        },
    },
}
